/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-restricted-globals */
import React, { useEffect, useState, useRef } from 'react';
import Modal from 'react-bootstrap/Modal';
import {
  getCustomerMarkupForAgentApi,
  deleteMarkUp,
} from '../../../api/profileApi';
import { getUserAgentId } from '../../../shared/helper-utils/localStorage';
import AppButton from '../../../shared/components/app-button/AppButton';
import AddOrUpdateMarkup from './AddOrUpdateMarkup';
import AppAlert from '../../../shared/components/app-alert/AppAlert';
import AppLink from '../../../shared/components/app-link/AppLink';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
import AccountsPageHorizontalBar from '../accounts/AccountsPageHorizontalBar';

function AgentMarkupPage() {
  const [markupList, setMarkupList] = useState([]);
  const [openMarkupModal, setOpenMarkupModal] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const selectedMarkUpRef = useRef(undefined);
  const [markupForDelete, setMarkupForDelete] = useState(undefined);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getMarkupList = async () => {
    const res = await getCustomerMarkupForAgentApi(getUserAgentId());
    if (res?.Root?.Status === 'OK') {
      const { CustomerMarkup } = res.Root.Result;
      const list = Array.isArray(CustomerMarkup)
        ? CustomerMarkup
        : [CustomerMarkup];
      setMarkupList(list);
    } else {
      setMarkupList([]);
      setAlert({
        variant: 'error',
        title: 'Mark up',
        description: res?.Root?.Message,
      });
    }
  };

  useEffect(() => {
    getMarkupList();
  }, []);

  const handleShowMarkupModal = () => {
    setOpenMarkupModal(true);
  };

  const handleAddModalClose = async (isRefresh) => {
    if (isRefresh) {
      await getMarkupList();
    }
    selectedMarkUpRef.current = undefined;
    setOpenMarkupModal(false);
  };

  const handleOpenEditModal = (markUp) => {
    selectedMarkUpRef.current = markUp;
    setOpenMarkupModal(true);
  };

  const handleOpenDeleteMarkUp = (id) => {
    setMarkupForDelete(id);
    setOpenDeleteModal(true);
  };

  const handleCloseDeleteMarkupModal = () => {
    setOpenDeleteModal(false);
    setMarkupForDelete(undefined);
  };

  const handleDeleteMarkUp = async () => {
    setIsLoading(true);
    const response = await deleteMarkUp(markupForDelete);
    if (response && response.Root.Status === 'OK') {
      setOpenDeleteModal(false);
      setAlert({
        variant: 'success',
        title: 'Delete Mark up',
        description: response.Root.Message,
      });
      await getMarkupList();
    } else {
      setAlert({
        variant: 'error',
        title: 'Delete Mark up',
        description: response.Root.Message,
      });
    }
    setIsLoading(false);
  };

  return (
    <section className="agent-markup-page py-4">
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          title={alert.title}
          description={alert.description}
          variant={alert.variant}
          showIcon={false}
          onHide={() => setAlert(undefined)}
        />
      )}
      <AccountsPageHorizontalBar selectedPage="agent-markup" />
      <div className="agent-markup-page_container">
        <div className="agent-markup-page_header d-flex align-items-center justify-content-between">
          <span className="agent-markup-page_header_title">Markup</span>
          <AppButton
            btnText="Add Markup"
            variant="secondary"
            className="fs-14"
            onClick={() => handleShowMarkupModal(true)}
          >
            Add Markup
          </AppButton>
        </div>
        <div className="markup-list-container p-3">
          {markupList.length > 0 ? (
            <div className="overflow-auto table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>Markup</th>
                    <th>Added By</th>
                    <th>Carrier</th>
                    <th>Service Type</th>
                    <th>Flat</th>
                    <th>BaseFare</th>
                    <th>YQ</th>
                    <th>TAX</th>
                    <th>Edit </th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {markupList.map((markup) => (
                    <tr key={markup.markupid}>
                      <td>{markup.markupid}</td>
                      <td>{markup.addedby}</td>
                      <td>{markup.carrier}</td>
                      <td>{markup.servicetype}</td>
                      <td>{markup.markup_flat}</td>
                      <td>{markup.markup_bf}</td>
                      <td>{markup.markup_yq}</td>
                      <td>{markup.markup_tax}</td>
                      <td>
                        <AppLink
                          linkText="Edit"
                          onClick={() => handleOpenEditModal(markup)}
                        />
                      </td>
                      <td>
                        <AppLink
                          linkText="Delete"
                          onClick={() =>
                            handleOpenDeleteMarkUp(markup.markupid)
                          }
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div>No Markups Found</div>
          )}
        </div>
      </div>
      <Modal show={openMarkupModal}>
        <Modal.Header>
          <Modal.Title>
            {selectedMarkUpRef.current ? 'Edit' : 'Add'} Markup
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddOrUpdateMarkup
            onClose={handleAddModalClose}
            onAlert={setAlert}
            selectedMarkUp={selectedMarkUpRef.current}
          />
        </Modal.Body>
      </Modal>
      <Modal show={openDeleteModal}>
        <Modal.Header>
          <Modal.Title>Delete Markup</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {markupForDelete && (
              <p>
                Are you sure you want to delete Mark up with ID{' '}
                {markupForDelete}
              </p>
            )}
          </div>
          <div className="d-flex justify-content-end">
            <div className="d-flex gap-2">
              <AppButton
                btnText="Close"
                variant="outlined"
                onClick={handleCloseDeleteMarkupModal}
              />
              <AppButton
                btnText="Delete"
                onClick={handleDeleteMarkUp}
                variant="primary"
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </section>
  );
}

export default AgentMarkupPage;
